module.exports = __webpack_public_path__ + "img/bring-forward.83037c9f.svg";